import { useTranslation } from "react-i18next";
import { CheckCircle2 } from "lucide-react";
import { NeuCard } from "../../components/neu/Neu";
import { MissingFaceBanner } from "./MissingFaceBanner";

// تبويب تفعيل الوجه: يعرض إما البانر الحالي أو حالة "الجميع جاهز".
export const EmployeesFaceTab = ({ employees, onDone }) => {
  const { t } = useTranslation();
  const pending = employees.filter((e) => !e.face_enrolled);

  if (pending.length === 0) {
    return (
      <NeuCard className="text-center" data-testid="employees-face-empty">
        <div className="mx-auto grid h-14 w-14 place-items-center rounded-2xl bg-success/10 text-success shadow-neu-in">
          <CheckCircle2 className="h-7 w-7" />
        </div>
        <p className="mt-4 text-base font-bold text-foreground">
          {t("employees.empty.face")}
        </p>
        <p className="mt-1 text-xs text-muted-foreground">
          {t("employees.missingFaceHint")}
        </p>
      </NeuCard>
    );
  }

  return (
    <div data-testid="employees-face-tab">
      <MissingFaceBanner employees={employees} onDone={onDone} />
    </div>
  );
};
